import * as React from 'react';
import './index.css';
import { DynamicTagGroup } from '@/components/DynamicTag';
// eslint-disable-next-line import/no-cycle
import { attachments } from '@components/HomePage/ContentItems';
import ContentSuperItem from '../itemSuperCard/itemSuperCard';

export class DynamicTagItemView extends ContentSuperItem {
  // tags
  private getTagObject() {
    const { itemKey } = this.props;
    let tagObject;

    if (this.props?.data?.promotionTags?.discountTag) {
      tagObject = this.props?.data?.promotionTags.discountTag;
    } else if (itemKey && this.props?.data?.[itemKey] && this.props?.data?.[itemKey]?.tags) {
      tagObject = this.props?.data?.[itemKey];
    } else if (this.props?.data?.dynamicTags) {
      tagObject = this.props?.data?.dynamicTags;
    }
    if (!tagObject) {
      const attachment = attachments[itemKey];
      if (attachment && attachment.staticConfig && attachment.staticConfig.itemKey) {
        tagObject = this.props?.data?.[attachment.staticConfig.itemKey];
      }
    }
    return tagObject;
  }

  render() {
    const tagObject = this.getTagObject();
    const inputMaxLines = this.props.style?.maxLines === undefined ? 1 : this.props.style?.maxLines;
    const justifyContent = this.props.style?.justifyContent || 'flex-start';
    const dynamicTagIsZeroMargin = this.props.style?.dynamicTagIsZeroMargin === undefined ? false : this.props.style?.dynamicTagIsZeroMargin;

    return (
      tagObject && tagObject?.tags ? (
        <view style={{ flexShrink: 1 }}>
          <DynamicTagGroup {...tagObject} maxLines={inputMaxLines} justifyContent={justifyContent} isZeroMargin={dynamicTagIsZeroMargin} customHandleOnTagClick={this.props?.customHandleOnTagClick} />
        </view>
      ) : null
    );
  }
}
